export const REPORT_SET_ANSWERS = 'REPORT_SET_ANSWERS';
export const REPORT_SET_QUIZ_ID = 'REPORT_SET_QUIZ_ID';
export const REPORT_SET_PAGE = 'REPORT_SET_PAGE';
export const REPORT_SET_DATE_FROM = 'REPORT_SET_DATE_FROM';
export const REPORT_SET_DATE_TO = 'REPORT_SET_DATE_TO';
export const REPORT_RESET_STATE = 'REPORT_RESET_STATE';
export const REPORT_SET_EXPORT_EMAIL = 'REPORT_SET_EXPORT_EMAIL';



/** WEBPACK FOOTER **
 ** ./src/store/modules/report/tableData/types.js
 **/